import { noop } from 'lodash';
import React, { createContext, ReactNode, useContext, useState } from 'react';

interface ApplicationContextType {
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  loggedinState: boolean;
}

const defaultContext: ApplicationContextType = {
  setLoggedIn: noop,
  loggedinState: false,
};

const ApplicationContext = createContext<ApplicationContextType>(defaultContext);

interface ApplicationProviderProps {
  children: ReactNode;
}

const ApplicationProvider: React.FC<ApplicationProviderProps> = ({ children }) => {
  const [loggedinState, setLoggedIn] = useState<boolean>(false);
  return <ApplicationContext.Provider value={{ setLoggedIn, loggedinState }}>{children}</ApplicationContext.Provider>;
};

export default ApplicationProvider;

export const useAppProvider = () => useContext(ApplicationContext);
